// Constants & pure helpers per il Social Studio.
// Estratti da SocialStudioTab.jsx (iter 274) per ridurre il file principale.

// iter v28 r98 — Brochure ELIMINATA definitivamente (richiesta utente:
// "elimina definitivamente brochure"). Manteniamo solo `brochure_social`
// (carousel multi-slide) e nuova occ_prezzo_nuovo.
export const STATIC_FORMATS = [];

// 4 layout (struttura/font) — Free vede solo "moderno", Pro tutti
// iter v28 r117 — Rinomina layout: i 4 nomi corrispondono ESATTAMENTE
// ai preview /tmp/preview_v3_*.png approvati dall'utente.
// Backend `_post_composer_v2.normalize_layout()` mappa qualsiasi vecchio
// valore a "moderno" (opzione B — reset richiesto dall'utente).
export const STATIC_LAYOUT_OPTIONS = [
  { key: "moderno", name: "Moderno", pro: false },
  { key: "elegante", name: "Elegante", pro: true },
  { key: "minimal", name: "Minimal", pro: true },
  { key: "lussuoso", name: "Lussuoso", pro: true },
];

// 8 palette — Free vede solo "verde_brera", Pro tutte.
// IMPORTANTE (iter 275): allineato 1:1 con `staticTemplate/tokens.js::COLORS`
// così Social Studio + Brochure + Volantino usano la STESSA palette. Quando
// l'utente sceglie un colore qui, la brochure usa esattamente lo stesso
// accent invece di cadere sul fallback `verde_brera`.
import { COLORS as BROCHURE_COLORS } from "@/components/staticTemplate/tokens";

// iter v29 r136 — User M1453: i colori del social editor devono essere
// ESATTAMENTE quelli del profilo brand (tutti 15 sbloccati). Prima 12/15
// erano "Pro-only" → incoerenza: l'utente sceglieva "Lavanda" come colore
// brand nel profilo, poi nel social non lo poteva usare. Adesso tutti
// tier "free" (il gating Pro/Free resta sui LAYOUT — 1 free, 3 pro).
export const STATIC_COLOR_OPTIONS = [
  { key: "verde_salvia",        name: BROCHURE_COLORS.verde_salvia.name,        swatch: BROCHURE_COLORS.verde_salvia.swatch,        tier: "free" },
  { key: "verde_tenue",         name: BROCHURE_COLORS.verde_tenue.name,         swatch: BROCHURE_COLORS.verde_tenue.swatch,         tier: "free" },
  { key: "giallo_pastello",     name: BROCHURE_COLORS.giallo_pastello.name,     swatch: BROCHURE_COLORS.giallo_pastello.swatch,     tier: "free" },
  { key: "beige_sabbia",        name: BROCHURE_COLORS.beige_sabbia.name,        swatch: BROCHURE_COLORS.beige_sabbia.swatch,        tier: "free" },
  { key: "terracotta_chiaro",   name: BROCHURE_COLORS.terracotta_chiaro.name,   swatch: BROCHURE_COLORS.terracotta_chiaro.swatch,   tier: "free" },
  { key: "terracotta_classico", name: BROCHURE_COLORS.terracotta_classico.name, swatch: BROCHURE_COLORS.terracotta_classico.swatch, tier: "free" },
  { key: "rosso_polvere",       name: BROCHURE_COLORS.rosso_polvere.name,       swatch: BROCHURE_COLORS.rosso_polvere.swatch,       tier: "free" },
  { key: "rosa_cipria",         name: BROCHURE_COLORS.rosa_cipria.name,         swatch: BROCHURE_COLORS.rosa_cipria.swatch,         tier: "free" },
  { key: "lavanda_polvere",     name: BROCHURE_COLORS.lavanda_polvere.name,     swatch: BROCHURE_COLORS.lavanda_polvere.swatch,     tier: "free" },
  { key: "blu_polvere",         name: BROCHURE_COLORS.blu_polvere.name,         swatch: BROCHURE_COLORS.blu_polvere.swatch,         tier: "free" },
  { key: "grigio_perla",        name: BROCHURE_COLORS.grigio_perla.name,        swatch: BROCHURE_COLORS.grigio_perla.swatch,        tier: "free" },
  { key: "marrone_scuro",       name: BROCHURE_COLORS.marrone_scuro.name,       swatch: BROCHURE_COLORS.marrone_scuro.swatch,       tier: "free" },
  { key: "bianco",              name: BROCHURE_COLORS.bianco.name,              swatch: BROCHURE_COLORS.bianco.swatch,              tier: "free" },
  { key: "nero",                name: BROCHURE_COLORS.nero.name,                swatch: BROCHURE_COLORS.nero.swatch,                tier: "free" },
  { key: "notte",               name: BROCHURE_COLORS.notte.name,               swatch: BROCHURE_COLORS.notte.swatch,               tier: "free" },
].map((c) => ({ ...c, pro: false }));

// Mini-anteprima visiva dei 4 layout (per il selettore)
export const LAYOUT_MINI = {
  elegante: [
    { h: "10px", w: "60%", c: "#7C8B6E", a: "flex-start" },
    { h: "3px", w: "40%", c: "#7C8B6E", a: "flex-start" },
  ],
  luxury: [
    { h: "9px", w: "50%", c: "#1C1C1A", a: "center" },
    { h: "2px", w: "60%", c: "#7C8B6E", a: "center" },
    { h: "3px", w: "30%", c: "#1C1C1A", a: "center" },
  ],
  moderno: [
    { h: "5px", w: "100%", c: "#1C1C1A", a: "flex-start" },
    { h: "5px", w: "70%", c: "#1C1C1A", a: "flex-start" },
    { h: "5px", w: "85%", c: "#1C1C1A", a: "flex-start" },
  ],
  minimal: [
    { h: "2px", w: "30%", c: "#7C8B6E", a: "flex-start" },
    { h: "4px", w: "55%", c: "#1C1C1A", a: "flex-start" },
    { h: "2px", w: "40%", c: "#1C1C1A", a: "flex-start" },
  ],
  contemporary: [
    // mock: foto + sfumatura brand-color sotto
    { h: "13px", w: "100%", c: "linear-gradient(180deg, transparent, #7C8B6E)", a: "flex-end", isGradient: true },
    { h: "3px", w: "70%", c: "#FBFAF6", a: "flex-start" },
    { h: "2px", w: "55%", c: "#FBFAF6", a: "flex-start" },
  ],
};

// Mappa formato → kind per archivio "I miei contenuti".
export function classifyKind(active) {
  if (!active) return "other";
  if (active === "brochure_social") return "carousel";
  if (active === "volantino_stima") return "volantino";
  if (active === "occ_open_house" || active === "occ_venduto" || active === "occ_prezzo_nuovo") return "post";
  if (active.startsWith("story_") || active === "open_house") {
    return active === "open_house" ? "post" : "story";
  }
  if (active === "carousel") return "carousel";
  if (active === "reel" || active === "before_after") return "reel";
  return "post";
}

export function labelForFormat(active, manifest) {
  const title = manifest?.property?.title || "";
  const labels = {
    occ_open_house: "Open House",
    occ_venduto: "Venduto",
    occ_prezzo_nuovo: "Prezzo nuovo",
    brochure_social: "Scheda social",
    volantino_stima: "Volantino stima",
  };
  const base = labels[active] || active;
  return title ? `${base} · ${title}` : base;
}
